@if (isLoading) {
<div>
    <mat-spinner></mat-spinner>
    <p>Intégration en cours ...</p>
</div>
}
<flowchart (loadingComplete)="traceComplete()" [hidden]="isLoading"></flowchart>

